export default __webpack_public_path__ + "static/media/profile-form-location.1247208c.svg";